import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './PhoneNumberDetail.css';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { fetchPhoneNumberById, updatePhoneNumberQualityAsync } from '../store/slices/phoneNumbersSlice';

const PhoneNumberDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { selectedPhoneNumber, loadingSelected, updateQualityLoading } = useAppSelector(state => state.phoneNumbers);
  const [quality, setQuality] = useState('NA');

  useEffect(() => {
    if (id) dispatch(fetchPhoneNumberById(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (selectedPhoneNumber) setQuality(selectedPhoneNumber.qualityRating || 'NA');
  }, [selectedPhoneNumber]);

  const handleUpdateQuality = async () => {
    if (!selectedPhoneNumber) return;
    await dispatch(updatePhoneNumberQualityAsync({ id: selectedPhoneNumber.id, qualityRating: quality })).unwrap().catch(() => {});
    alert('Quality rating updated (dev preview).');
  };

  if (loadingSelected || !selectedPhoneNumber) {
    return (
      <div className="phone-number-detail">
        <button className="btn-back" onClick={() => navigate(-1)}>← Back</button>
        <div>Loading phone number...</div>
      </div>
    );
  }

  return (
    <div className="phone-number-detail">
      <button className="btn-back" onClick={() => navigate(-1)}>← Back</button>

      <div className="detail-header">
        <h2>{selectedPhoneNumber.displayNumber}</h2>
        <div className="status-block">
          <span className={`status ${selectedPhoneNumber.status?.toLowerCase()}`}>{selectedPhoneNumber.status}</span>
        </div>
      </div>

      <div className="detail-grid">
        <div className="detail-card">
          <h3>Verified Name</h3>
          <div>{selectedPhoneNumber.verifiedName || 'Not Set'}</div>
        </div>

        <div className="detail-card">
          <h3>Quality Rating</h3>
          <select value={quality} onChange={(e) => setQuality(e.target.value)}>
            <option value="GREEN">GREEN</option>
            <option value="YELLOW">YELLOW</option>
            <option value="RED">RED</option>
            <option value="NA">NA</option>
          </select>
          <button className="btn-update" onClick={handleUpdateQuality} disabled={updateQualityLoading}>
            {updateQualityLoading ? 'Updating...' : 'Update Rating'}
          </button>
        </div>

        <div className="detail-card">
          <h3>Account Mode</h3>
          <div>{selectedPhoneNumber.accountMode}</div>
        </div>

        <div className="detail-card">
          <h3>Verification Status</h3>
          <div>{selectedPhoneNumber.codeVerificationStatus}</div>
        </div>

        <div className="detail-card">
          <h3>Last Verified</h3>
          <div>{selectedPhoneNumber.lastVerified || 'Never'}</div>
        </div>

        <div className="detail-card">
          <h3>Official Account</h3>
          <div>{selectedPhoneNumber.isOfficialBusinessAccount ? 'Yes' : 'No'}</div>
        </div>
      </div>
    </div>
  );
};

export default PhoneNumberDetail;
